import React from "react";
import { BannerContainer } from "./styles";
import { useAuth } from "~context/AuthContext";
import { useLocation } from "react-router-dom";

interface InfoBannerProps {
}

const InfoBanner: React.FC<InfoBannerProps> = () => {
  const {
    isAuthenticated,
    authState: { user },
  } = useAuth();

  const location = useLocation();

  if (!isAuthenticated()) return null;

  if (location.pathname.startsWith('/eligibility')) return null;

  if (user?.hasSubmittedMandatoryDocsButNotValidated)
    return <BannerContainer>Ton CV et ton document d’identité sont en cours de validation. Une fois validés, tu pourras choisir ton mentor.</BannerContainer>;
  else if(user?.status === "awaiting_mandatory_docs")
     return <BannerContainer>Pense à charger ton CV et un document d’identité. C’est indispensable pour que tu puisses choisir un mentor.</BannerContainer>;

   return null;
};

export default InfoBanner;